import { LOCAL_STORAGE_KEYS } from 'utils/constants/localStorageKeys';
import mainConstants from 'utils/constants/main';
import { getFallbackLng } from 'components/AppTranslationWrapper/functions';

const initialState = {
  isNewProfile: false,
  cameFrom: null,
  urlParameters: null,
  lastOpenedUrl: '',
  isNewUser: !localStorage.getItem(LOCAL_STORAGE_KEYS.JOINED_AT),
  lang: getFallbackLng(),
};

// eslint-disable-next-line default-param-last
export function main(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case mainConstants.SET_IS_NEW_PROFILE:
      return {
        ...state,
        isNewProfile: payload,
      };
    case mainConstants.SET_CAME_FROM:
      return {
        ...state,
        cameFrom: payload || null,
      };
    case mainConstants.SET_URL_PARAMETERS:
      return {
        ...state,
        urlParameters: payload || null,
      };
    case mainConstants.SET_LANG:
      return {
        ...state,
        lang: payload,
      };
    case mainConstants.SET_LAST_OPENED_URL:
      return {
        ...state,
        lastOpenedUrl: payload,
      };
    default:
      return state;
  }
}
